/**
 * @generated SignedSource<<7e54dd2911c4e9747c1025a35418234d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsFiltersFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeFilter_session">;
  readonly " $fragmentType": "LessonsFiltersFragment_session";
};
export type LessonsFiltersFragment_session$key = {
  readonly " $data"?: LessonsFiltersFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsFiltersFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonTypeFilter_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "a4beb008428ffae20d72f136f41bba80";

export default node;
